module.exports = __webpack_public_path__ + "static/icons/img-banner-2.89c4a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-home/img-banner-2.png
// module id = ftuB
// module chunks = 1